import React from 'react';
import PropTypes from 'prop-types';
import { withFooterDrawer } from '../../components/Footer';
import Header from '../../components/Header';
import Section from '../../components/Section';
import PricingStrip from '../../components/PricingStrip';
import Style from '../../components/Style';
import { H2, H4, P1 } from '../../components/Typography';

class Privacy extends React.PureComponent {
  render() {
    let pagePadding = '7rem 2rem 0';
    let P1Margin = '0 0 2rem';

    return (
      <div style={{ position: 'relative' }}>
        <Section
          backgroundColor={Style.Colors.shadow4}
          angle={17}
          style={{
            position: 'absolute',
            top: 'calc(15rem + 30vw)',
            left: 0,
            zIndex: 0,
            opacity: 0.1,
          }}
          contentStyle={{ height: '30rem' }}
        />

        <Section
          style={{ position: 'relative', zIndex: 1 }}
          contentStyle={{ padding: pagePadding }}
        >
          <div style={{ maxWidth: '70rem', margin: '3rem auto' }}>
            <H4>Storytape Agreements</H4>
          </div>
          <div style={{ maxWidth: '70rem', margin: '3rem auto' }}>
            <P1 style={{ margin: P1Margin }}>
              <strong>TERMS AND CONDITIONS OF USE</strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Last Modified: November 10, 2017</strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Pro Church Tools Inc., also operating under the trade name
              Storytape, is a corporation formed pursuant to the{' '}
              <em>Business Corporations Act</em>, R.S.O. 1990, c. B.16 in
              Ontario, Canada. In consideration for permitting your access to
              our website, products and services, and other good and valuable
              consideration, you agree as follows:
            </P1>
            <P1 style={{ margin: P1Margin }}>
              These terms and conditions (the &quot;<strong>Terms</strong>&quot;)
              form a legally binding agreement which govern your access to and
              use of Pro Church Tools Inc.'s, (&quot;we&quot;, &quot;us&quot; or
              &quot;our&quot;) website (&quot;<strong>Website</strong>&quot;)
              and our online service, in which we license non-exclusive rights
              to stock video clips (“<strong>Clips</strong>”) on a per project
              basis (the &quot;<strong>Service</strong>&quot;). The Website and
              Service are hosted at{' '}
              <a href="https://www.storytape.com" class="uri">
                https://www.storytape.com
              </a>{' '}
              and other domains and sub-domains.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              By using our Website and Service, you, the user (&quot;<strong>you</strong>&quot;
              or &quot;<strong>your</strong>&quot;), represent that you are at
              least 18 years old. If you are using the Website and/or Service or
              are licensing content from us on behalf of, or in the employ of,
              an organization (corporation, trust, partnership, church,
              not-for-profit, etc.), you are agreeing to these Terms for that
              organization and representing and warranting that you have the
              authority to bind that organization to these Terms. In such a
              case, &quot;you&quot; and &quot;your&quot; will also refer to that
              organization and yourself individually. For greater clarity, both
              you as an individual and your organization are legally bound by
              these terms which form an agreement between you and Pro Church
              Tools Inc.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Licensing Video Clips </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              We offer three different subscription models to access and license
              our Clips; Starter, Basic and Unlimited (collectively the “<strong>Subscription Models</strong>”):
            </P1>
            <ul>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  <strong>Starter Subscription</strong> – Credits you to license
                  a maximum of 5 Clips per month, each in 1080p resolution;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  <strong>Basic Subscription</strong> – Credits you to license a
                  maximum of 20 Clips per month, each in 1080p resolution; and
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  <strong>Unlimited Subscription</strong> – Allows you to
                  license an unlimited number of Clips per month in either 1080p
                  or 4K resolution.
                </P1>
              </li>
            </ul>
            <P1 style={{ margin: P1Margin }}>
              Credits under both the Starter and Basic Subscriptions do not
              carry forward month-to-month.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Licensing Terms</strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Where you apply your account credits, under any Subscription
              Model, to download a Clip from us, we grant you, and only you, a
              non-exclusive, royalty-free, worldwide license to use the Clip in
              a single video project, in accordance with the terms of this
              agreement.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              You agree and acknowledge that we, or where applicable, our
              independent content providers (“<strong>ICP’s</strong>”), will
              continue to own the Clips licensed to you under each Subscription
              Model. We are not transferring, selling or assigning title or
              ownership of any Clips to you. Nor are we waiving any copyright or
              moral rights to Clips.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <em>Single Project Use </em>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Our Service is different from most stock video licensing websites.
              Our Clips are licensed on a per project basis. This means that you
              are only permitted to use Clips licensed and downloaded from us in
              a single video project (the “<strong>Single Use Restriction</strong>”).
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Each time you select a Clip to license and download, you will be
              prompted to provide a brief description of the project you will
              use the Clip in. This helps us identify what video projects you
              licensed our content for. It is your responsibility to accurately
              describe the video project(s). You agree that we may ask you, at
              any time, to update or provide more clarity on which video
              project(s) you have, or intend to use, our Clips in. We may also
              temporarily suspend your ability to download a Clip until you
              provide an accurate description of your project(s), or if we
              believe your use or intended use is in breach of these Terms.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Under both the Starter and Basic subscriptions, if you wish to use
              a Clip more than once, for example in a second video project, you
              are required to use a second credit for the same Clip. However, if
              you subscribe to our Unlimited plan, you can use each Clip you
              download in multiple video projects. Under the Unlimited plan, we
              still ask that you provide a description of each project you are
              using our Clips in. This helps us track and monitor permitted
              usage of our Clips.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <em>
                Restrictions on Sublicensing or Selling our Clips (License
                Restrictions)
              </em>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              You agree that our Clips shall not be used on, or in connection
              with, any other stock video website or business that is
              competitive in nature with our Service.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Where you create a video project that uses a Clip from us, you may
              only sell or license your video where our Clip(s) do not comprise
              more than twenty-five percent (25%) of the overall duration of the
              video (the “<strong>25% Restriction</strong>”).
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Notwithstanding the above, where you create a video for a single
              customers or client in the course of carrying on a video
              production service, you are permitted to license the right to use
              your video, with our Clips comprising in excess of 25% of the
              overall video, so long as; (1) you comply with our Single Use
              Restriction; and (2) your customer or client is restricted from
              sub-licensing or selling the video, or any of our Clips or
              portions of our Clips.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Prior to the sale or licensing of your videos, which include our
              Clips, you shall disclose to the purchaser, licensee or other
              applicable third-party, the fact that we own the Clips and that
              their use is restricted by these Terms, including for example, the
              Single Use Restriction and the 25% Restriction. This means that
              your customers or clients are restricted from on-selling or
              re-licensing our Clips, or using our Clips, or portions thereof,
              in any other video, project or business.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <em>Use of our Clips (License Restrictions)</em>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              You agree that you will not use, or allow the use of our Clips in
              videos, advertisements, or in a context (for example on a website)
              that associates our Clips with unlawful, obscene, defamatory,
              libelous, harmful, hateful, harassing, bullying, pornographic,
              threatening, racially or ethnically offensive or abusive content,
              products or services.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              You further agree that you will not use, or allow the use of our
              Clips in videos, movies, advertisements, or in a context (for
              example on a website) that may encourage a criminal offense, give
              rise to civil liability (including for example intellectual
              property infringement), or violate any local, state, provincial,
              national or international law or regulation, or that is otherwise
              inappropriate.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Some of our Clips may feature individual (“<strong>Models</strong>”).
              You agree that you will not use any of our Clips and will not
              display Models in any videos or other content in a manner which a
              reasonable person, in the Model’s circumstances, would find
              offensive or objectionable. Without limiting the forgoing, you
              agree that Clips displaying a Model will not be used in connection
              with, or in any way related to videos, businesses, projects or
              websites which:
            </P1>
            <ul>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Have or display pornographic, nude, unlawful or immoral
                  content;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Have or display, whether for sale or otherwise, unlawful drugs
                  or tobacco products;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Portray the Model negatively or are derogatory to him or her;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Portray the Model as accepting of or promoting defamatory,
                  libelous, harmful, hateful, harassing, bullying, pornographic,
                  threatening, racially or ethnically offensive or abusive
                  content, products or services; or
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Advertise or promote adult entertainment establishments or
                  businesses, escort or dating services.
                </P1>
              </li>
            </ul>
            <P1 style={{ margin: P1Margin }}>
              Where our Clips are used in violation of these Terms, you agree to
              immediately delete any such infringing content and remove it from
              the Internet.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Pricing and Taxes </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              For current pricing on each Subscription Model, please visit{' '}
              <a href="https://www.storytape.com/pricing" class="uri">
                https://www.storytape.com/pricing
              </a>. Prices listed are subject to change, however, we will not
              change the pricing for current subscribers, so long as you remain
              a subscriber.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Prices displayed are an invitation to make an offer and are
              subject to acceptance by us. Even in the event of an automated
              acceptance by us, you agree that we shall have the opportunity to
              review and accept subscription orders and confirm your payment
              information for a period of seven (7) days following your
              subscription.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Prices are subject to the addition of sales taxes. You agree to
              pay all sales taxes applicable to this agreement, arising from
              your subscription or the licensing of Clips from us.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Additional terms, including but not limited to, price, tax,
              payment, discounts, refunds or cancellations may be specified on
              the Website and Service. Those terms, as amended from time to
              time, are incorporated by reference and form part of this
              agreement.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Payment</strong> <strong>Terms</strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Payment for your subscription is due monthly, in advance. In the
              alternative, you may elect to pay for your subscription on an
              annual basis.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              We collect credit card information from you online via a
              third-party payment processor (“<strong>Payment Processor</strong>”).
              You agree and authorize us to bill your credit card via our
              Payment Processor.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Your personal and payment information is collected and processed
              in accordance with our Privacy Policy. By providing your payment
              information, you consent to such processing and warrant that all
              information provided by you is accurate.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Although the Payment Processor’s electronic forms may be hosted on
              our Website or Service, we accept no responsibility or liability
              for their collection and storage of your payment details or
              personal information. The Payment Processor may have their own
              terms and conditions and privacy policies, which apply to your
              personal information and payment transactions. Please contact us
              if you have any questions concerning our Payment Processor.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Refunds </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Once you select a Clip to license and it is made available for
              download, your account credit(s) are non-refundable under the
              Starter and Basic plans, please choose Clips carefully.
            </P1>
            <P1 style={{ margin: P1Margin }}>Proprietary Rights</P1>
            <P1 style={{ margin: P1Margin }}>
              Our Website and Service contain open source and public domain
              content, licenced content as well as proprietary content owned by
              us and by third parties (including ICPs).
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Aside from Clips which you are licensed to use, on a limited basis
              in accordance with these Terms, you are not permitted to copy,
              share, sell or distribute any other content (including but not
              limited to text, images, trademarks, videos and audio) on the
              Website or Service, without the express consent of the owner. All
              other contents of the Website and Service, including but not
              limited to, the computer code, is the property of Pro Church Tools
              Inc. and/or our ICP’s with all rights reserved.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Without limiting the forgoing, you are not permitted to, (a)
              record, copy, share, reproduce, remove watermarks, sell or
              distribute any content on our Website or Service without our
              express written permission; or (b) use any trademark or trade name
              of Pro Church Tools Inc. including our logo, without our express
              permission.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Your Content</strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              In some cases, our Website and Service may permit you and other
              third-parties to upload, contribute and post content (&quot;<strong>User Content</strong>&quot;).
              We do not pre-screen User Content uploaded or posted to the
              Website or Service by you or other users. You grant us a
              non-exclusive, transferable, sub-licensable, royalty-free,
              worldwide license to use any of your User Content that you post,
              record, upload or otherwise contribute in order to facilitate the
              ordinary use of the Website and Service.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              We may, but have no obligation to, remove User Content that we
              determine in our sole discretion to be unlawful, damaging, or
              violate any third-party's intellectual property rights, these
              Terms or any policy incorporated by reference herein.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              In addition to our Acceptable Use Policy, you agree not to use the
              Website or Service in any manner which may infringe the copyright
              or other intellectual property rights of any third party or in any
              manner which is unlawful, offensive, threatening, libelous,
              defamatory, obscene or in violation of these Terms.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Property and Feedback</strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              All rights, title and interest in and to the Website, the Service
              and their contents (including our Clips) are and will remain the
              exclusive property of Pro Church Tools Inc., our ICP’s and
              licensors, including all Intellectual Property Rights (as defined
              below), even if we incorporate any of your Feedback (as defined
              below) into subsequent versions.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              The Website, Service and their contents, including our video Clips
              are protected by copyright, trademark and other laws of Canada,
              the United States and foreign countries. Except as expressly
              permitted in these Terms, you may not reproduce, modify or prepare
              derivative works, distribute, sell, transfer, publicly display,
              publicly perform, transmit, or otherwise use our Website, Service,
              Clips or any portion of their contents.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              All feedback, comments, and suggestions for improvements (“<strong>Feedback</strong>”)
              that you provide to us, in any form, will immediately become our
              sole and exclusive property. You agree to transfer and assign to
              us all of your rights, title and interest in and to all of your
              Feedback, including all worldwide patent rights, copyright rights,
              and other intellectual property rights (collectively, the “<strong>Intellectual Property Rights</strong>”).
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>
                <span class="underline">
                  ACCEPTANCE OF RISK AND DISCLAIMERS
                </span>
              </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>
                EVERYTHING ON OUR WEBSITE AND ALL PRODUCTS (INCLUDING OUR CLIPS)
                OFFERED AS PART OF OUR SERVICE ARE PROVIDED &quot;AS IS&quot;
                WITHOUT WARRANTY OF ANY KIND INCLUDING ALL IMPLIED WARRANTIES
                AND CONDITIONS OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
                PURPOSE.{' '}
              </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>
                YOU AGREE THAT WHILE WE STRIVE TO HAVE ERROR FREE AND
                UNINTERRUPTED SERVICE, WE DO NOT GUARANTEE THE ABSENCE OF
                INTERRUPTIONS NOR SHALL YOU HOLD US LIABLE FOR ANY DAMAGE SUCH
                INTERRUPTIONS MAY CAUSE.
              </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>
                <span class="underline">LIMITATION OF OUR LIABILITY</span>
              </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>
                YOU AGREE THAT, TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO
                EVENT WILL WE, OUR AFFILIATES, OFFICERS, DIRECTORS,
                SHAREHOLDERS, EMPLOYEES, CONTRACTORS, AGENTS, SUPPLIERS, OR
                LICENSORS BE LIABLE, HOWSOEVER CAUSED, FOR ANY DIRECT, INDIRECT,
                SPECIAL, INCIDENTAL, PUNITIVE, EXEMPLARY OR CONSEQUENTIAL
                DAMAGES, REGARDLESS OF LEGAL THEORY AND WHETHER OR NOT WE HAVE
                BEEN WARNED OF THE POSSIBILITY OF SUCH DAMAGES AND WHETHER THOSE
                DAMAGES WERE FORESEEABLE OR NOT.
              </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>
                IF YOU ARE DISSATISFIED WITH THE WEBSITE OR SERVICE, OR DO NOT
                AGREE WITH ANY PART OF THESE TERMS, OR HAVE ANY OTHER DISPUTE OR
                CLAIM WITH OR AGAINST US, OUR AFFILATES, OFFICERS, DIRECTORS,
                SHAREHOLDERS, EMPLOYEES, CONTRACTORS, AGENTS, SUPPLIERS OR
                LICENSORS, THEN YOUR REMEDIES ARE TO (I) DISCONTINUE ACCESSING
                AND USING THE WEBSITE AND SERVICE; AND (II) TERMINATE YOUR
                SUBSCRIPTION WITH US, IN ACCORDANCE WITH THESE TERMS.
              </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>
                IN ADDITION TO YOUR AGREEMENT TO NOT HOLD THE ABOVE ENTITIES AND
                PERSONS LIABLE FOR ANY DAMAGES, IN THE EVENT A COURT OR
                ARBITRATOR OF COMPETENT JURISDICTION DECLINES TO UPHOLD SAID
                CLAUSE, YOU AGREE THAT IN NO CIRCUMSTANCES SHALL THE AGGREGATE
                LIABILITY FOR ANY AND ALL CLAIMS RELATING TO OR IN ANY WAY
                ARISING FROM THE USE OF OUR WEBSITE OR SERVICE, OR IN ANY WAY
                RELATED TO THESE TERMS, BE MORE THAN THE AMOUNT PAID BY YOU TO
                US (IF ANY).
              </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>
                <span class="underline">
                  YOU AGREE AND ACKNOWLEDGE THAT ACCESS TO OUR WEBSITE AND
                  SERVICE, AND IF YOU ARE A PAYING CUSTOMER, THE FEES PAID BY
                  YOU, REFLECT THE ALLOCATION OF RISK SET FORTH IN THESE TERMS
                  AND THAT WE WOULD NOT ENTER INTO THIS AGREEMENT OR GRANT
                  ACCESS TO THE WEBSITE OR SERVICE WITHOUT THESE RESTRICTIONS
                  AND LIMITATIONS ON OUR LIABILITY.
                </span>
              </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>
                <span class="underline">INDEMNIFICATION AND HOLD HARMLESS</span>
              </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>
                YOU AGREE TO INDEMNIFY US, OUR AFFILIATES, EMPLOYEES,
                SHAREHOLDERS, DIRECTORS, AGENTS, REPRESENTATIVES AND
                CONTRACTORS, AND TO DEFEND AND HOLD EACH OF THEM HARMLESS, FROM
                ANY AND ALL CLAIMS AND LIABILITIES (INCLUDING REASONABLE LEGAL
                FEES) WHICH MAY ARISE FROM, AMONG OTHER THINGS (I) YOUR
                VIOLATION OF THESE TERMS, OR ANY POLICY INCOROPRATED BY
                REFERENCE; (II) YOUR VIOLATION OF ANY THIRD-PARTY RIGHT; OR
                (III) ANY BREACH OF A REPRESENTATION OR WARRANTY MADE BY YOU TO
                US, EITHER IN THESE TERMS, PRIVACY POLICY OR OTHERWISE.
              </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>
                <span class="underline">AMENDMENTS </span>
              </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>
                AS OUR WEBSITE AND SERVICE CONTINUE TO CHANGE, WE MAY, AT ANY
                TIME, REVISE THESE TERMS AND OUR POLICIES BY UPDATING THIS PAGE
                OR THE PAGE HOSTING THE RELEVANT POLICY. THE DATE OF THE LAST
                VERSION OF THESE TERMS IS POSTED ABOVE. AS YOU ARE BOUND BY
                THESE TERMS EACH TIME YOU VISIT OUR WEBSITE OR USE OUR SERVICE,
                YOU ARE RESPONSIBLE FOR PERIODICALLY REVIEWING THE AMENDMENTS TO
                THESE TERMS AND YOU ARE DEEMED TO HAVE ACCEPTED AND AGREED TO
                SUCH AMENDMENTS BY ACCESSING AND USING THE WEBSITE AND SERVICE
                AFTER SUCH AMENDMENTS HAVE BEEN POSTED. IF YOU DO NOT AGREE WITH
                THE AMENDMENTS, YOU CAN TERMINATE YOUR SUBSCRIPTION AND STOP
                ACCESSING THE WEBSITE AND SERVICE. WE MAY ALSO UNDERTAKE TO SEND
                YOU NOTICE OF ANY CHANGES TO THE TERMS OR POLICIES.{' '}
              </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Copyright Notice</strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              If you believe that your copyrighted work has been used in a way
              that constitutes copyright infringement and is accessible on our
              Website or Service, please notify us at hello@storytape.com. While
              we take no responsibility for any user other third-party who
              breaches your copyright or other intellectual property rights, we
              may, in our sole discretion and without liability, undertake to
              attempt to contact the infringer on your behalf and remove the
              content from our Service.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Linked Sites</strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Whether or not we are affiliated with sites or third-party vendors
              that may be linked to our Website or Service, we are not
              responsible for their content (the &quot;<strong>Linked Sites</strong>&quot;).
              The Linked Sites are for your convenience only and you access them
              at your own risk. We and other users provide links and references
              to material on other websites not owned or operated by us. Links
              found on our Website or Service are not an endorsement and we do
              not represent or warrant the accuracy or truth of the contents of
              information found on said websites. You access those links and
              corresponding sites at your own risk.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>
                Law of the Contract (Governing Law) and Jurisdiction.{' '}
              </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              These Terms, all documents incorporated by reference and your
              relationship with us shall be governed by, construed and enforced
              in accordance with the laws of the Province of Ontario, Canada,
              (and any Canadian federal laws applicable therein) as it is
              applied to agreements entered into and to be performed entirely
              within such province.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              You hereby agree to irrevocably and unconditionally submit to the
              jurisdiction of the courts and tribunals of Ontario, Canada
              (including the Federal courts and tribunals as applicable therein)
              to settle any disputes arising out of or in any way related to
              these Terms, all documents incorporated by reference and your
              relationship with us.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Severability </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              If any provision of these Terms are found to be unlawful, void, or
              for any reason unenforceable, then that provision shall be deemed
              severable from this agreement and shall not affect the validity
              and enforceability of any remaining provisions.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>No Construction Against Drafter</strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              If an ambiguity or question of intent arises with respect to any
              provision of these Terms, the Terms shall be construed as if
              drafted jointly by the parties and no presumption or burden of
              proof will arise favouring or disfavouring either party by virtue
              of authorship of any of the provisions of these Terms.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Waiver of Class Proceedings and Trial By Jury</strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              To the extent permitted by law, you hereby waive your right to
              participate in any class action lawsuits against us, our
              contractors, employees, shareholders, successors, assigns and
              directors.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              To the extent permitted by law, you further waive any right to a
              trial by jury, should such a right exist, in relation to any legal
              dispute connected to or in any way arising out of these Terms.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Incorporation by Reference</strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              All policies referred to in these Terms or anywhere on our Website
              or Service are hereby incorporated by reference and form part of
              this agreement, including but not limited to our Privacy Policy
              and Acceptable Use Policy.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Termination</strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              You may cancel your subscription or account with us at any time.
              However, monthly subscription credits purchased to download Clips
              from us are not refundable. You should ensure that you use all of
              your account credits prior to canceling your subscription.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              We may also cancel, suspend or terminate your account if we
              reasonably believe you have or may breach these Terms or any
              policy incorporated by reference.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              The cancellation, suspension or termination of your subscription
              or account with us shall not terminate this agreement. In
              particular, and without limiting the generality of the foregoing,
              any provision concerning the limitation of our liability, your
              indemnification obligations, intellectual property rights and
              obligations, settling disputes (including the jurisdiction and
              choice of law) shall remain binding.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Assignment </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              You agree that we may assign this agreement to any successor or
              assignee, whether pursuant to the purchase of our Website and
              Service, the transfer of control of Pro Church Tools Inc., or
              otherwise.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Right to Seek Injunction</strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Violation of these Terms may cause us irreparable harm and,
              therefore, you agree that we will be entitled to seek
              extraordinary relief including, but not limited to, temporary
              restraining orders, preliminary injunctions and permanent
              injunctions without the necessity of posting a bond or other
              security, in addition to and without prejudice to any other rights
              or remedies that we may have for a breach of these Terms.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Waiver</strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Our failure to enforce any right or provision of these Terms will
              not be deemed a waiver of such right or provision.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Other Terms </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Any new features that augment or enhance the current Website and
              Service, including the release of new versions, new Clips,
              products or services, tools and resources, shall be subject to
              these Terms. Continued use of the Website and Service after any
              such changes shall constitute your consent to such changes.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Entire Agreement</strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              This is the entire agreement between the parties relating to the
              matters contained herein and shall not be modified except in
              writing, signed by a duly authorized representative of Pro Church
              Tools Inc.
            </P1>
          </div>

          <div style={{ maxWidth: '70rem', margin: '3rem auto' }}>
            <P1 style={{ margin: P1Margin }}>
              <strong>PRIVACY POLICY</strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Last Modified: May 25, 2018</strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              This privacy policy applies to the collection and use of your
              personal information via our (Pro Church Tools Inc.’s) website,
              hosted at{' '}
              <a href="https://www.storytape.com" class="uri">
                https://www.storytape.com
              </a>.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              By accessing our website and uploading your personal information,
              you consent to the collection and use of your personal information
              in accordance with this privacy policy, which may be updated from
              time to time.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <em>Collection of Personal and Business Information</em>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              When using our website and licensing content from us, we may
              collect your personal and business information, including your:
            </P1>
            <ul>
              <li>
                <P1 style={{ margin: P1Margin }}>Name;</P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Business or Organization Name;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>Address;</P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>Email address;</P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>Phone number;</P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Comments, feedback, reviews and other information you upload
                  or provide via the website;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  IP address and location data, including such data collected
                  via{' '}
                  <a href="https://www.google.com/analytics">
                    Google Analytics
                  </a>;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Website statistics and analytics data regarding your use of
                  the website;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Other types of raw data relating to how you interact with the
                  website, for example, your browser information and session
                  duration;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Payment, banking and credit card information, which is
                  collected and stored via a third-party payment provider; and
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  All other information you provide to us on our website or
                  otherwise.
                </P1>
              </li>
            </ul>
            <P1 style={{ margin: P1Margin }}>
              Third-party service providers we use may have their own privacy
              policies on the collection and use of your information which
              either we or you provide them.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>
                TO THE EXTENT YOU PROVIDE US WITH, OR UPLOAD DATA THAT INCLUDES
                THE PERSONAL INFORMATION OF ANOTHER PERSON, YOU REPRESENT AND
                WARRANT THAT YOU HAVE THEIR AUTHORIZATION TO PROVIDE US WITH
                THAT INFORMATION IN ACCORDANCE WITH THIS PRIVACY POLICY AND OUR
                TERMS AND CONDITIONS OF USE.{' '}
              </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <em>Credit Card and Payment Processing Companies</em>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              We collect credit card and payment information from you via a
              third-party. Their additional terms of service and privacy
              policies may apply to the collection and use of your personal
              information. If you have questions regarding our payment
              processor, please contact us.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Although the payment processor’s electronic forms may be displayed
              on our website, you are providing the payment information directly
              to them. We will have access to your personal information via the
              payment provider, although not your full credit card number(s).
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <em>The Use of Your Personal Information</em>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              The collection of your personal information may be used to:
            </P1>
            <ul>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Facilitate the operation of the website, including:
                </P1>
                <ul>
                  <li>
                    <P1 style={{ margin: P1Margin }}>
                      providing your personal information to third-party service
                      providers, such as payment processors; and
                    </P1>
                  </li>
                  <li>
                    <P1 style={{ margin: P1Margin }}>
                      delivering licensed content to you;
                    </P1>
                  </li>
                </ul>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Verify your contact information;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Promote our website and offerings to you in various forms of
                  communication;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Support and improve the website and service we offer;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>Provide customer support;</P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Communicate with you about your account, subscription and
                  services we offer;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Bill and collect money owed to us;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Pursue available legal remedies to us and to prosecute or
                  defend a court, arbitration or similar proceeding;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Send or display informational and promotional materials from
                  us, our partners, advertisers or third parties to you;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  To meet legal requirements;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  To enforce compliance with any terms and conditions and
                  applicable law; and
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Enhance our service offerings to you and offer you related
                  products and services, whether by email, advertisements or
                  otherwise.
                </P1>
              </li>
            </ul>
            <blockquote>
              <P1 style={{ margin: P1Margin }}>
                <strong>
                  IN ADDITION, WE RESERVE THE RIGHT TO PROVIDE YOUR CONTENT AND
                  INFORMATION (INCLUDING BUT NOT LIMITED TO YOUR PERSONAL
                  INFORMATION) UPLOADED OR COLLECTED BY OUR WEBSITE OR OTHERWISE
                  PROVIDED TO US, TO THIRD PARTIES IF REQUIRED BY LAW IN ANY
                  JURISDICTION.
                </strong>
              </P1>
              <P1 style={{ margin: P1Margin }}>
                <strong>
                  IF WE ARE REQUIRED BY LAW TO MAKE ANY DISCLOSURE OF YOUR
                  CONTENT OR PERSONAL OR BUSINESS INFORMATION, WE <em>MAY</em> (<span class="underline">BUT ARE NOT OBLIGATED TO</span>)
                  PROVIDE YOU WITH WRITTEN NOTICE (TO THE EXTENT PERMITTED BY
                  LAW) PRIOR TO SUCH DISCLOSURE SO THAT YOU MAY TAKE APPROPRIATE
                  ACTION.{' '}
                </strong>
              </P1>
            </blockquote>
            <P1 style={{ margin: P1Margin }}>
              <em>
                The Disclosure of Your Personal Information and Access to It
              </em>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              We may share your personal information with our payment providers,
              advertisers, partners and employees to use that information for
              one or more of the purposes in which that information was
              collected.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              We also operate the website in conjunction with our independent
              contractors and independent web developers and designers. Our
              independent contractors may have access to your personal
              information in providing services to us, or providing you with
              access to the website and your licensed content. We may use a
              variety of service providers, contractors, servers or employees in
              locations both inside and outside of Canada, which may make your
              personal information the subject of foreign laws and foreign legal
              proceedings.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              As at the date of the last version of this privacy policy, we use
              the following additional service providers, aside from our
              independent contractors and web development and design firm:
            </P1>
            <ul>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Amazon Web Services, Inc. and/or its affiliates (“AWS”) is
                  used for hosting website data, including the data you submit,
                  and which may include personal information. For more
                  information on AWS’s privacy practices, visit{' '}
                  <a
                    href="https://aws.amazon.com/compliance/gdpr-center"
                    class="uri"
                  >
                    https://aws.amazon.com/compliance/gdpr-center
                  </a>;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Rollbar Inc. (<a href="https://rollbar.com" class="uri">
                    https://rollbar.com
                  </a>) is used for error monitoring related to the Website. For
                  more information on Rollbar Inc.’s privacy practices, visit{' '}
                  <a href="https://rollbar.com/privacy" class="uri">
                    https://rollbar.com/privacy
                  </a>; and
                </P1>
              </li>
            </ul>
            <P1 style={{ margin: P1Margin }}>
              We may also disclose your personal information to our successors
              (if our business or the website is acquired by another legal
              entity) or any assignee of our assets relating to the website and
              our content.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <em>
                European Union’s General Data Protection Regulation (“GDPR”)
              </em>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Our privacy practices intend to meet the requirements of the GDPR.
              As a company that may process the personal information of persons
              who reside in or are citizens of the European Union (a “European
              person”), we have implemented appropriate technical and
              organizational measures to meet the GDPR’s requirements and
              protect European persons personal information. Our technical
              measures to protect personal information take into account current
              technology available and the costs of implementing that technology
              in addition to the nature, scope, context and purposes of the
              personal information collected and processed. If you have any
              questions about our technical and organizational measures to meet
              the GDPR requirements, please contact us.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>
                WHILE WE TAKE MEASURES TO PROTECT PERSONAL INFORMATION, YOU
                AGREE THAT, TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT
                WILL WE, OUR AFFILIATES, OFFICERS, DIRECTORS, SHAREHOLDERS,
                EMPLOYEES, CONTRACTORS, AGENTS, SUPPLIERS, OR LICENSORS BE
                LIABLE, HOWSOEVER CAUSED, FOR THE LOSS OR THEFT OF YOUR PERSONAL
                INFORMATION OR ANY DAMAGES CAUSED AS A RESULT THEREOF, SO LONG
                AS WE WERE NOT GROSSLY NEGLIGENT IN THE PROTECTION OF THAT
                INFORMATION.
              </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <em>Retention of Your Personal Information</em>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              We keep your personal information for as long as it is
              required for the purpose for which it was collected.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <em>Inquiries</em>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              If you believe that we have not adhered to this Privacy Policy or
              would like to request an amendment to your personal information
              being held by us, please contact our Privacy Officer by e-mail at{' '}
              <a href="mailto:hello@storytape.com">hello@storytape.com</a>.
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <em>Use of Cookies</em>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              Our Website may place a &quot;cookie&quot; in the browser files of
              your computer. You can disable cookies on your web browser,
              however, doing so may interrupt the proper use of our Website.
            </P1>
          </div>

          <div style={{ maxWidth: '70rem', margin: '3rem auto' }}>
            <P1 style={{ margin: P1Margin }}>
              <strong>ACCEPTABLE USE POLICY </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              <strong>Last Modified: November 10, 2017 </strong>
            </P1>
            <P1 style={{ margin: P1Margin }}>
              You agree to use our Website and Service in accordance with the
              following acceptable use policy.
            </P1>
            <P1 style={{ margin: P1Margin }}>You agree that you:</P1>
            <ol type="1">
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Will not disclose your password or transfer your account to
                  any third-party, or allow any third-party to access your
                  account;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Will not use your account for your own commercial purposes by
                  sublicensing any rights granted by the Terms without
                  permission or, in any way, sharing the benefit of your account
                  with others. Your account is non-transferrable and may only be
                  used by you;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Will not upload, copy, distribute, share, or otherwise use
                  content that is unlawful, obscene, defamatory, libelous,
                  harmful, hateful, harassing, bullying, pornographic,
                  threatening, racially or ethnically offensive or abusive, that
                  would violate another person's rights (including their
                  intellectual property rights), constitute or encourage a
                  criminal offense, give rise to civil liability, or violate any
                  local, state, provincial, national or international law or
                  regulation, or that is otherwise inappropriate;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Will not upload, copy, distribute, share or otherwise use
                  content that contains or embodies software viruses or any
                  other malicious computer code that is designed to interrupt,
                  undermine, destroy or limit the functionality of any computer
                  software, hardware or communications equipment, or that is
                  designed to perform functions on any software, hardware or
                  equipment without the owner's express consent;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Will not impersonate any person or entity;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Will not access the Website and Service by any means other
                  than through the interface provided by us for use in accessing
                  the Website and Service. This includes not using or launching
                  any automated system including, without limitation, any
                  spider, robot (or &quot;bot&quot;) or scraper.
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Will not interfere with or disrupt the Website, Service or
                  servers or networks connected thereto, make the Service
                  available over a network (other than our network) where it
                  could be used by others or disobey any requirements,
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Will not collect, harvest or store any personally identifiable
                  information, including user account information, from us;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Will not use the Website or Service in a way that has any
                  unlawful or fraudulent purpose or effect;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Will not translate, reverse engineer, decompile, disassemble,
                  modify or create derivative works based on the Website or
                  Service, in whole or in part;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Will not circumvent, disable, violate or otherwise interfere
                  with any security related feature of the Website or Service;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Will not rent, lease, sublicense, transfer, sell, trade,
                  resell or exploit for any commercial purposes any portion of
                  the Website or Service (including, without limitation, your
                  account information, use of the Service or access to the
                  Service;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Will not use the Website or Service in any way that violates
                  the Terms, or that aids, encourages, or purports to authorize
                  anyone else to violate the Terms or this policy;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Will not use the Website or Service in any way that
                  intentionally or unintentionally violates any applicable
                  local, state, provincial, national or international law, rule
                  or regulation;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Will not employ misleading e-mail addresses or falsify
                  information in any part of any communication;
                </P1>
              </li>
              <li>
                <P1 style={{ margin: P1Margin }}>
                  Will not upload, transmit, disseminate, post, store or post
                  links to any content that:
                </P1>
                <ol type="a">
                  <li>
                    <P1 style={{ margin: P1Margin }}>
                      prohibits from transmitting or posting by law, or by
                      contractual or fiduciary relationship;
                    </P1>
                  </li>
                  <li>
                    <P1 style={{ margin: P1Margin }}>
                      facilitates hacking or unauthorized access or use of data,
                      systems, servers or networks including any attempt to
                      probe, scan or test for vulnerabilities, or to breach
                      security or authentication measures;
                    </P1>
                  </li>
                  <li>
                    <P1 style={{ margin: P1Margin }}>
                      interferes with service to any user, system or network by
                      using flooding techniques, overloading a system or a
                      network, staging or broadcasting an attack or any other
                      means resulting in a crash of a host either deliberately
                      or by negligence;
                    </P1>
                  </li>
                  <li>
                    <P1 style={{ margin: P1Margin }}>
                      infringes on, or contributes to any infringement of, any
                      intellectual property, material protected by copyright,
                      trademark, patent, trade secret or proprietary right of
                      any party.
                    </P1>
                  </li>
                </ol>
              </li>
            </ol>
            <P1 style={{ margin: P1Margin }}>
              We reserve the right in our sole discretion to revise this policy,
              which shall be posted on the Website and Service.
            </P1>
          </div>

          <PricingStrip />
        </Section>
      </div>
    );
  }
}

export default withFooterDrawer()(Privacy);



// WEBPACK FOOTER //
// ./src/routes/privacy/Privacy.js